/* ===========================
   Velmora Template - Main JS
   =========================== */

document.addEventListener('DOMContentLoaded', function () {

  /* Mobile search toggle */
  var searchToggleBtn = document.getElementById('btn-search-toggle');
  if (searchToggleBtn) {
    searchToggleBtn.addEventListener('click', function () {
      var sb = document.querySelector('.search-bar');
      sb.classList.toggle('search-mobile-open');
      if (sb.classList.contains('search-mobile-open')) {
        sb.querySelector('input[type="search"]').focus();
      }
    });
  }

  /* =====================
     Hero Slider — clean fade + content slide-in
     ===================== */
  const slides = document.querySelectorAll('.slide');
  const dots = document.querySelectorAll('.dot');
  let current = 0;
  let autoplay;

  function showSlide(n) {
    // Remove active from all (triggers fade-out + content reset)
    slides.forEach(s => s.classList.remove('active'));
    dots.forEach(d => d.classList.remove('active'));
    // Set new current
    current = (n + slides.length) % slides.length;
    // Add active (triggers fade-in + content animate-in)
    if (slides[current]) slides[current].classList.add('active');
    if (dots[current]) dots[current].classList.add('active');
  }

  function nextSlide() { showSlide(current + 1); }
  function prevSlide() { showSlide(current - 1); }
  function startAuto() { autoplay = setInterval(nextSlide, 5000); }
  function stopAuto() { clearInterval(autoplay); }

  if (slides.length) {
    // Show first slide immediately
    showSlide(0);
    startAuto();
    dots.forEach((d, i) => d.addEventListener('click', () => { stopAuto(); showSlide(i); startAuto(); }));
    const nextBtn = document.querySelector('.slider-next');
    const prevBtn = document.querySelector('.slider-prev');
    if (nextBtn) nextBtn.addEventListener('click', () => { stopAuto(); nextSlide(); startAuto(); });
    if (prevBtn) prevBtn.addEventListener('click', () => { stopAuto(); prevSlide(); startAuto(); });
  }

  /* =====================
     Sticky Navbar — only the nav bar sticks after header scrolls away
     ===================== */
  const navBar     = document.querySelector('.nav-bar');
  const mainHeader = document.querySelector('.main-header');
  if (navBar && mainHeader) {
    // Insert an invisible placeholder right after the nav-bar so the
    // layout doesn't jump when the bar switches to position:fixed
    const placeholder = document.createElement('div');
    placeholder.className = 'nav-sticky-placeholder';
    navBar.after(placeholder);

    let threshold = 0;
    function computeThreshold() {
      // Distance from page top to the bottom of main-header (= top of nav-bar)
      threshold = mainHeader.offsetTop + mainHeader.offsetHeight;
    }
    computeThreshold();
    window.addEventListener('resize', computeThreshold, { passive: true });

    window.addEventListener('scroll', function stickyNav() {
      if (window.scrollY >= threshold) {
        placeholder.style.height = navBar.offsetHeight + 'px';
        navBar.classList.add('nav-fixed');
      } else {
        placeholder.style.height = '0';
        navBar.classList.remove('nav-fixed');
      }
    }, { passive: true });
  }

  /* =====================
     Products Carousel — prev/next scroll
     ===================== */
  const prodCarousel = document.getElementById('products-carousel');
  const prodPrev = document.getElementById('prod-prev');
  const prodNext = document.getElementById('prod-next');
  function wireCarousel(carouselId, prevId, nextId) {
    const carousel = document.getElementById(carouselId);
    const prev = document.getElementById(prevId);
    const next = document.getElementById(nextId);
    if (!carousel || !prev || !next) return;
    const amt = () => { const c = carousel.querySelector('.product-card'); return c ? c.offsetWidth : 260; };
    prev.addEventListener('click', () => carousel.scrollBy({ left: -amt(), behavior: 'smooth' }));
    next.addEventListener('click', () => carousel.scrollBy({ left: amt(), behavior: 'smooth' }));
  }
  wireCarousel('products-carousel', 'prod-prev', 'prod-next');
  wireCarousel('feat-carousel', 'feat-prev', 'feat-next');
  wireCarousel('wl-upsell-carousel', 'wl-upsell-prev', 'wl-upsell-next');
  wireCarousel('upsell-carousel', 'upsell-prev', 'upsell-next');

  /* =====================
     Product Gallery Thumbnails
     ===================== */
  const thumbs = document.querySelectorAll('.product-thumbnails img');
  const mainImg = document.querySelector('.main-image img');
  thumbs.forEach(thumb => {
    thumb.addEventListener('click', () => {
      thumbs.forEach(t => t.classList.remove('active'));
      thumb.classList.add('active');
      if (mainImg) mainImg.src = thumb.src.replace(/-150x150|-300x300/g, '');
    });
  });

  /* =====================
     Quantity Buttons
     ===================== */
  document.querySelectorAll('.qty-minus').forEach(btn => {
    btn.addEventListener('click', () => {
      const input = btn.nextElementSibling;
      if (input && parseInt(input.value) > 1) input.value = parseInt(input.value) - 1;
    });
  });
  document.querySelectorAll('.qty-plus').forEach(btn => {
    btn.addEventListener('click', () => {
      const input = btn.previousElementSibling;
      if (input) input.value = parseInt(input.value) + 1;
    });
  });

  /* =====================
     Mobile Menu Toggle
     ===================== */
  const mobileToggle = document.getElementById('mobile-menu-toggle');
  const mobileNavBar = document.getElementById('main-nav');

  function closeMobileMenu() {
    if (!mobileNavBar) return;
    mobileNavBar.classList.remove('mobile-open');
    if (mobileToggle) mobileToggle.setAttribute('aria-expanded', 'false');
  }

  if (mobileToggle && mobileNavBar) {
    mobileToggle.addEventListener('click', function(e) {
      e.stopPropagation();
      var isOpen = mobileNavBar.classList.toggle('mobile-open');
      mobileToggle.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
    });

    // Accordion sub-menus — tap parent link to expand/collapse on mobile
    mobileNavBar.querySelectorAll('.nav-menu > li').forEach(function(li) {
      var sub = li.querySelector('.dropdown, .mega-menu');
      if (!sub) return;
      li.querySelector('a').addEventListener('click', function(e) {
        if (window.innerWidth > 768) return;
        e.preventDefault();
        var wasOpen = sub.classList.contains('mobile-sub-open');
        mobileNavBar.querySelectorAll('.mobile-sub-open').forEach(function(s) { s.classList.remove('mobile-sub-open'); });
        if (!wasOpen) sub.classList.add('mobile-sub-open');
      });
    });

    // Close menu when a leaf link (inside dropdown/mega) is tapped
    mobileNavBar.querySelectorAll('.dropdown a, .mega-menu a').forEach(function(a) {
      a.addEventListener('click', function() { closeMobileMenu(); });
    });

    // Close on outside click
    document.addEventListener('click', function(e) {
      if (mobileNavBar.classList.contains('mobile-open') &&
          !mobileNavBar.contains(e.target) &&
          e.target !== mobileToggle) {
        closeMobileMenu();
      }
    });
  }

  /* =====================
     Scroll to Top
     ===================== */
  const scrollBtn = document.createElement('button');
  scrollBtn.innerHTML = '↑';
  scrollBtn.id = 'scroll-top';
  scrollBtn.style.cssText = 'position:fixed;bottom:30px;right:30px;width:44px;height:44px;border-radius:50%;background:var(--primary);color:#fff;border:none;cursor:pointer;font-size:18px;display:none;z-index:999;box-shadow:0 4px 14px rgba(0,0,0,0.2);transition:all 0.3s;';
  document.body.appendChild(scrollBtn);
  window.addEventListener('scroll', () => {
    scrollBtn.style.display = window.scrollY > 400 ? 'flex' : 'none';
    scrollBtn.style.alignItems = 'center';
    scrollBtn.style.justifyContent = 'center';
  });
  scrollBtn.addEventListener('click', () => window.scrollTo({ top: 0, behavior: 'smooth' }));

  /* =====================
     OVERLAY HELPERS
     ===================== */
  const overlay = document.getElementById('site-overlay');

  function openOverlay() {
    if (overlay) overlay.classList.add('active');
    document.body.style.overflow = 'hidden';
  }
  function closeOverlay() {
    if (overlay) overlay.classList.remove('active');
    document.body.style.overflow = '';
  }

  if (overlay) {
    overlay.addEventListener('click', () => {
      closeCartDrawer();
      closeLoginModal();
      closeOverlay();
    });
  }

  /* =====================
     CART DRAWER — Shopify AJAX Cart API
     ===================== */
  const cartDrawer = document.getElementById('cart-drawer');
  const btnCart    = document.getElementById('btn-cart');
  const closeCartBtn = document.getElementById('cart-drawer-close');

  function openCartDrawer() {
    if (!cartDrawer) return;
    cartDrawer.classList.add('open');
    openOverlay();
  }
  function closeCartDrawer() {
    if (!cartDrawer) return;
    cartDrawer.classList.remove('open');
  }

  if (btnCart)       btnCart.addEventListener('click', openCartDrawer);
  if (closeCartBtn)  closeCartBtn.addEventListener('click', () => { closeCartDrawer(); closeOverlay(); });

  // Format cents to money string using shop's money format
  function formatMoney(cents) {
    var amount = (cents / 100).toFixed(2);
    var format = window.moneyFormat || 'Rs. {{amount}}';
    return format.replace('{{amount}}', amount)
                 .replace('{{amount_no_decimals}}', Math.floor(cents / 100))
                 .replace('{{amount_with_comma_separator}}', amount.replace('.', ','))
                 .replace('{{amount_no_decimals_with_comma_separator}}', String(Math.floor(cents / 100)).replace(/\B(?=(\d{2})+(?!\d))/g, ','));
  }

  // Re-render drawer from a /cart.js response object
  function renderCartDrawer(cart) {
    const body       = document.getElementById('cart-drawer-body');
    const countEl    = document.getElementById('cart-drawer-count');
    const subtotalEl = document.querySelector('.cart-subtotal-amount');
    const badgeEls   = document.querySelectorAll('.cart-count-badge');

    if (countEl)    countEl.textContent = '(' + cart.item_count + ')';
    if (subtotalEl) subtotalEl.textContent = formatMoney(cart.total_price);
    badgeEls.forEach(b => b.textContent = cart.item_count);

    if (!body) return;

    if (cart.item_count === 0) {
      body.innerHTML = '<div class="cart-empty"><div class="cart-empty-icon">🛍️</div><h4>Your cart is empty</h4><p>Add some products to get started</p><a href="/collections/all" class="btn btn-primary">Shop Now</a></div>';
      return;
    }

    body.innerHTML = '<div class="cart-items-list">' + cart.items.map(function(item, index) {
      var line = index + 1;
      var variantLabel = (item.variant_title && item.variant_title !== 'Default Title') ? '<span class="cart-item-meta">' + item.variant_title + '</span>' : '';
      return '<div class="cart-item">' +
        '<img src="' + item.image + '" alt="' + item.title + '" width="80" height="80" />' +
        '<div class="cart-item-info">' +
          '<h5><a href="' + item.url + '">' + item.product_title + '</a></h5>' +
          variantLabel +
          '<span class="cart-item-price">' + formatMoney(item.final_line_price) + '</span>' +
          '<div class="cart-item-qty-row">' +
            '<button class="cart-qty-btn" data-line="' + line + '" data-qty="' + (item.quantity - 1) + '">−</button>' +
            '<input type="number" value="' + item.quantity + '" min="1" class="cart-item-qty-input" data-line="' + line + '" />' +
            '<button class="cart-qty-btn" data-line="' + line + '" data-qty="' + (item.quantity + 1) + '">+</button>' +
          '</div>' +
        '</div>' +
        '<button class="cart-item-remove" data-line="' + line + '" aria-label="Remove">&times;</button>' +
      '</div>';
    }).join('') + '</div>';

    // Wire qty and remove buttons
    body.querySelectorAll('.cart-qty-btn').forEach(function(btn) {
      btn.addEventListener('click', function() {
        var qty = parseInt(this.dataset.qty);
        if (qty < 0) qty = 0;
        cartChange(parseInt(this.dataset.line), qty);
      });
    });
    body.querySelectorAll('.cart-item-remove').forEach(function(btn) {
      btn.addEventListener('click', function() {
        cartChange(parseInt(this.dataset.line), 0);
      });
    });
    body.querySelectorAll('.cart-item-qty-input').forEach(function(input) {
      input.addEventListener('change', function() {
        cartChange(parseInt(this.dataset.line), Math.max(0, parseInt(this.value) || 0));
      });
    });
  }

  // POST /cart/change.js
  function cartChange(line, quantity) {
    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ line: line, quantity: quantity })
    })
    .then(function(r) { return r.json(); })
    .then(function(cart) { renderCartDrawer(cart); });
  }

  // POST /cart/add.js then open drawer
  function addToCart(variantId, quantity) {
    var btn = document.querySelector('.btn-add-cart[data-variant-id="' + variantId + '"], .btn-add-to-cart');
    if (btn) { btn.textContent = 'Adding…'; btn.disabled = true; }

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: variantId, quantity: quantity || 1 })
    })
    .then(function(r) { return r.json(); })
    .then(function() {
      return fetch('/cart.js').then(function(r) { return r.json(); });
    })
    .then(function(cart) {
      renderCartDrawer(cart);
      openCartDrawer();
      if (btn) { btn.textContent = 'Add To Cart'; btn.disabled = false; }
    })
    .catch(function() {
      if (btn) { btn.textContent = 'Add To Cart'; btn.disabled = false; }
    });
  }

  // Wire product card "Add To Cart" buttons (data-variant-id required)
  document.querySelectorAll('.btn-add-cart').forEach(function(btn) {
    btn.addEventListener('click', function(e) {
      e.preventDefault();
      var variantId = this.dataset.variantId;
      if (!variantId) return;
      addToCart(parseInt(variantId), 1);
    });
  });

  // Wire product page "Add To Cart" form submit
  var productForm = document.getElementById('product-form');
  if (productForm) {
    productForm.addEventListener('submit', function(e) {
      e.preventDefault();
      var variantInput = document.getElementById('variant-id');
      var qtyInput     = document.getElementById('qty-input');
      if (!variantInput) return;
      addToCart(parseInt(variantInput.value), parseInt(qtyInput ? qtyInput.value : 1) || 1);
    });
  }

  // Load current cart state on page load
  fetch('/cart.js')
    .then(function(r) { return r.json(); })
    .then(function(cart) { renderCartDrawer(cart); });

  /* =====================
     LOGIN MODAL
     ===================== */
  const loginModal = document.getElementById('login-modal');
  const btnAccount = document.getElementById('btn-account');
  const closeLoginBtn = document.getElementById('close-login');

  function openLoginModal() {
    if (!loginModal) return;
    loginModal.classList.add('open');
    openOverlay();
  }
  function closeLoginModal() {
    if (!loginModal) return;
    loginModal.classList.remove('open');
  }

  if (btnAccount) {
    btnAccount.addEventListener('click', function (e) {
      e.preventDefault();
      openLoginModal();
    });
  }
  if (closeLoginBtn) closeLoginBtn.addEventListener('click', () => { closeLoginModal(); closeOverlay(); });

  // Scope all modal interactions to #login-modal to avoid conflicts with Shop.js injected forms
  function modalTabs(targetId) {
    if (!loginModal) return;
    loginModal.querySelectorAll('.modal-tab').forEach(function (t) { t.classList.remove('active'); });
    loginModal.querySelectorAll('.modal-panel').forEach(function (p) { p.classList.remove('active'); });
    var tab = loginModal.querySelector('[data-mtab="' + targetId + '"]');
    var panel = loginModal.querySelector('#' + targetId);
    if (tab) tab.classList.add('active');
    if (panel) panel.classList.add('active');
  }

  // Cross-links inside the modal ("Create one" / "Sign in")
  if (loginModal) {
    loginModal.querySelectorAll('[data-mtab-open]').forEach(function (link) {
      link.addEventListener('click', function (e) {
        e.preventDefault();
        modalTabs(this.dataset.mtabOpen);
      });
    });

    // Tab buttons inside modal
    loginModal.querySelectorAll('.modal-tab').forEach(function (tab) {
      tab.addEventListener('click', function () {
        modalTabs(this.getAttribute('data-mtab'));
      });
    });
  }

  // Auto-open modal on form error (set by Liquid when form.errors is present)
  if (window.__velmoraOpenModal) {
    openLoginModal();
    modalTabs(window.__velmoraOpenModal);
  }

  // Close modal on ESC key
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') {
      closeCartDrawer();
      closeLoginModal();
      closeMobileMenu();
      closeOverlay();
    }
  });

  /* =====================
     Product Page Tabs (Description / Additional Information / Reviews)
     ===================== */
  document.querySelectorAll('.product-tab').forEach(function(btn) {
    btn.addEventListener('click', function() {
      var target = this.getAttribute('data-tab');
      document.querySelectorAll('.product-tab').forEach(function(b) { b.classList.remove('active'); });
      document.querySelectorAll('.tab-panel').forEach(function(p) { p.classList.remove('active'); });
      this.classList.add('active');
      var panel = document.getElementById(target);
      if (panel) panel.classList.add('active');
    });
  });

  /* =====================
     Account page tabs (my-account.html)
     ===================== */
  const accountTabs = document.querySelectorAll('.account-tab-btn');
  accountTabs.forEach(btn => {
    btn.addEventListener('click', function () {
      const target = this.getAttribute('data-acctab');
      document.querySelectorAll('.account-tab-btn').forEach(b => b.classList.remove('active'));
      document.querySelectorAll('.account-tab-panel').forEach(p => p.classList.remove('active'));
      this.classList.add('active');
      const panel = document.getElementById(target);
      if (panel) panel.classList.add('active');
    });
  });

  // Handle hash on my-account page
  if (window.location.hash === '#register') {
    const regBtn = document.querySelector('[data-acctab="acct-register"]');
    if (regBtn) regBtn.click();
  }

  /* =====================
     Wishlist Toggle (add/remove)
     Stores full product objects so wishlist page can render without extra API calls.
     Schema: [{ id, variantId, title, price, comparePrice, image, url, available, sku }]
     ===================== */
  var WL_KEY = 'velmoraWishlist';

  function wlGet() {
    try { return JSON.parse(localStorage.getItem(WL_KEY) || '[]'); } catch(e) { return []; }
  }
  function wlSave(items) {
    localStorage.setItem(WL_KEY, JSON.stringify(items));
  }
  function wlUpdateBadge() {
    var count = wlGet().length;
    document.querySelectorAll('.wishlist-count-badge').forEach(function(b) { b.textContent = count; });
  }

  document.querySelectorAll('.btn-wishlist').forEach(function(btn) {
    var productId = parseInt(btn.dataset.productId);
    var items = wlGet();
    if (items.some(function(it) { return it.id === productId; })) {
      btn.classList.add('wishlisted');
    }

    btn.addEventListener('click', function(e) {
      e.preventDefault();
      var id = parseInt(this.dataset.productId);
      var items = wlGet();
      var idx = items.findIndex(function(it) { return it.id === id; });

      if (idx > -1) {
        items.splice(idx, 1);
        this.classList.remove('wishlisted');
        wlSave(items);
        wlUpdateBadge();
      } else {
        // Collect product data from the card/page DOM
        var card = this.closest('.product-card') || this.closest('.product-info') || this.closest('.product-single');
        var titleEl = card ? (card.querySelector('h1, h3') || card.querySelector('a')) : null;
        var title = titleEl ? titleEl.textContent.trim() : 'Product';
        var imgEl = card ? card.querySelector('img') : null;
        var image = imgEl ? imgEl.src : '';
        var linkEl = card ? card.querySelector('a[href]') : null;
        var url = linkEl ? linkEl.getAttribute('href') : '/';
        var addCartBtn = card ? card.querySelector('.btn-add-cart, .btn-add-to-cart') : null;
        var variantId = addCartBtn ? parseInt(addCartBtn.dataset.variantId) : 0;
        var variantIdInput = document.getElementById('variant-id');
        if (!variantId && variantIdInput) variantId = parseInt(variantIdInput.value);
        var priceEl = card ? card.querySelector('.product-price ins, .price ins') : null;
        var priceAllEl = card ? card.querySelector('.product-price, .price') : null;
        var priceText = (priceEl || priceAllEl) ? (priceEl || priceAllEl).textContent.replace(/[^0-9.]/g, '') : '0';
        var compareEl = card ? card.querySelector('.product-price del, .price del') : null;
        var compareText = compareEl ? compareEl.textContent.replace(/[^0-9.]/g, '') : '';

        items.push({
          id: id,
          variantId: variantId || 0,
          title: title,
          price: Math.round(parseFloat(priceText) * 100) || 0,
          comparePrice: compareText ? Math.round(parseFloat(compareText) * 100) : 0,
          image: image,
          url: url,
          available: true
        });
        this.classList.add('wishlisted');
        wlSave(items);
        wlUpdateBadge();
      }
    });
  });

  wlUpdateBadge();

  /* =====================
     COUPON CODE — Cart page
     Shopify does not accept discount codes via the cart form POST.
     The correct method is redirecting to /checkout?discount=CODE.
     ===================== */
  var couponInput    = document.getElementById('coupon-code-input');
  var couponBtn      = document.getElementById('apply-coupon-btn');
  var couponFeedback = document.getElementById('coupon-feedback');
  var checkoutBtn    = document.querySelector('.cart-checkout-btn');

  if (couponInput && couponBtn && checkoutBtn) {
    function setCouponFeedback(msg, type) {
      if (!couponFeedback) return;
      couponFeedback.textContent = msg;
      couponFeedback.className = 'coupon-feedback' + (type ? ' coupon-feedback--' + type : '');
    }

    // Restore a previously saved code so refreshing the page doesn't lose it
    var savedCode = sessionStorage.getItem('velmoraDiscount');
    if (savedCode) {
      couponInput.value = savedCode;
      checkoutBtn.href = '/checkout?discount=' + encodeURIComponent(savedCode);
      setCouponFeedback('✓ Code "' + savedCode + '" will be applied at checkout.', 'success');
    }

    couponBtn.addEventListener('click', function () {
      var code = couponInput.value.trim();

      if (!code) {
        setCouponFeedback('Please enter a coupon code.', 'error');
        couponInput.focus();
        return;
      }

      sessionStorage.setItem('velmoraDiscount', code);
      checkoutBtn.href = '/checkout?discount=' + encodeURIComponent(code);
      setCouponFeedback('✓ Code "' + code + '" will be applied at checkout.', 'success');

      couponBtn.textContent = 'Applied!';
      setTimeout(function () { couponBtn.textContent = 'Apply coupon'; }, 2000);
    });

    couponInput.addEventListener('keydown', function (e) {
      if (e.key === 'Enter') { e.preventDefault(); couponBtn.click(); }
    });

    // Clear saved code when input is manually emptied
    couponInput.addEventListener('input', function () {
      if (!this.value.trim()) {
        sessionStorage.removeItem('velmoraDiscount');
        checkoutBtn.href = '/checkout';
        setCouponFeedback('', '');
      }
    });
  }

  /* =====================
     Judge.me — fix timestamps, hide spinners
     ===================== */
  function fixJudgemeWidget() {
    document.querySelectorAll('.jdgm-rev__timestamp[data-content]').forEach(function(el) {
      var raw = el.getAttribute('data-content');
      if (!raw || el.textContent.trim()) return;
      try {
        var d = new Date(raw);
        el.textContent = d.toLocaleDateString('en-US', { year: 'numeric', month: 'short', day: 'numeric' });
      } catch(e) { el.textContent = raw.split(' ')[0]; }
      el.classList.remove('jdgm-spinner');
      el.style.cssText = '';
    });
    document.querySelectorAll('.jdgm-rev-widg__paginate-spinner-wrapper').forEach(function(el) {
      el.style.display = 'none';
    });
  }
  fixJudgemeWidget();
  setTimeout(fixJudgemeWidget, 1200);

});
